export class CampaignMemoApiError extends Error {
  constructor(
    public type: string,
    message?: string,
    public status?: number
  ) {
    super(message || type)
    this.name = 'CampaignMemoApiError'
  }
}
